import {
	Component
} from '@angular/core'

@Component({
	selector: 'heroes',
	templateUrl: '../views/heroes.component.html'
})

export class HeroesComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/heroes.component.ts